import React, { useState, useEffect } from "react";
import TopList from "./Nutrition/TopList";
import getWeekNumber from "../../../Utilities/getWeekNumber";
import NutrientReport from "./Nutrition/NutritionReport";
import EconomyReport from "./Economy/EconomyReport";
import EnvironmentReport from "./Environment/EnvironmentReport";

const LastWeek = ({ inventory, trash }) => {
  const [loaded, setLoaded] = useState(false);
  const [itemsFromLastWeek, setItemsFromLastWeek] = useState("");

  const getItemsFromLastWeek = (currentWeek) => {
    let tempListOfItems = [];

    inventory.forEach((item) => {
      let itemsDate = new Date(item.dates[item.dates.length - 1]);
      if (currentWeek === getWeekNumber(itemsDate)) {
        tempListOfItems.push(item);
      }
    });

    trash.forEach((item) => {
      let trashItemDate = new Date(item.dates[item.dates.length - 1]);

      if (currentWeek === getWeekNumber(trashItemDate)) {
        tempListOfItems.push(item);
      }
    });

    setItemsFromLastWeek(tempListOfItems);
  };

  useEffect(() => {
    if (itemsFromLastWeek !== "") {
      setLoaded(true);
    }
  }, [itemsFromLastWeek]);

  useEffect(() => {
    let currentWeek = getWeekNumber(new Date());
    getItemsFromLastWeek(currentWeek);
  }, []);

  return (
    <div className="reportBody">
      <h4 className="reportTitle">Last Week</h4>
      {!loaded ? (
        <p>Loading....</p>
      ) : itemsFromLastWeek.length > 0 ? (
        <React.Fragment>
          <EconomyReport list={itemsFromLastWeek} />
          <NutrientReport list={itemsFromLastWeek} />
          <EnvironmentReport list={itemsFromLastWeek} />
        </React.Fragment>
      ) : (
        <p style={{ marginTop: "70px" }}>No purchases this week</p>
      )}
    </div>
  );
};

export default LastWeek;
